export const SWIPE_REPLY_THRESHOLD = 56;
export const LONG_PRESS_MS = 550;
export const HIGHLIGHT_MS = 1200;

export const getReplyPreviewText = (msg, t) => {
  if (!msg) return "";
  if (msg.isDeleted) {
    return (
      t?.("one_to_one.original_message_unavailable") ||
      "Original message unavailable"
    );
  }
  const text = String(msg.text || "").trim();
  if (text) return text;
  if (msg.imageUrl) return `📷 ${t?.("one_to_one.photo") || "Photo"}`;
  if (msg.videoUrl) return `🎬 ${t?.("one_to_one.video") || "Video"}`;
  return "";
};

/** Resolve quoted author from replyTo (msgByUserId for personal/global, sender for others). */
export const getReplySender = (replyTo, senderField = "sender") => {
  if (!replyTo) return null;
  if (senderField === "msgByUserId") {
    return replyTo.msgByUserId || replyTo.sender || null;
  }
  return replyTo.sender || replyTo.msgByUserId || null;
};

export const getReplySenderName = (replyTo, senderField = "sender") => {
  const sender = getReplySender(replyTo, senderField);
  return sender?.userName || sender?.firstName || "";
};

/** True when the quoted original is in the currently loaded page (and not deleted). */
export const canJumpToLoadedReply = (replyTo, messages = []) => {
  if (!replyTo?._id || replyTo.isDeleted) return false;
  const id = String(replyTo._id);
  return messages.some((m) => m?._id != null && String(m._id) === id);
};

export const mergeMessagesById = (existing = [], incoming = []) => {
  const map = new Map();
  [...existing, ...incoming].forEach((msg) => {
    if (msg?._id) map.set(msg._id, msg);
  });
  return Array.from(map.values()).sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  );
};
